module.exports = __webpack_public_path__ + "fonts/Poppins-Medium.23528ec9.eot";